export default __webpack_public_path__ + "static/media/ic_exam_info_exercises.872ac188.svg";